import { useTranslation } from "react-i18next";
import { IconNoData } from "../../../common/icons/IconNoData/IconNoData";
import { IconRefresh } from "../../../common/icons/IconRefresh/IconRefresh";
import LeafButton from "../../../common/leaf/LeafButton/LeafButton";
import defaultContent from "../../../content/hat";

import "./ErrorPages.scss";
export const HATTimeoutError = ({ refetchFunction }: { refetchFunction: Function }) => {
  const { t } = useTranslation(["hat"]);
  return (
    <div className="HATTimeoutError">
      <IconNoData />
      <h2>{t("error.timeout", defaultContent.error.timeout as string)}</h2>
      <p>{t("error.unableToLoad", defaultContent.error.unableToLoad as string)}</p>
      <LeafButton clickAction={() => refetchFunction()} Icon={<IconRefresh color="black" />} id={""}>
        {t("error.refresh", defaultContent.error.refresh as string)}
      </LeafButton>
    </div>
  );
};
